// The token this person is aiming at (issue 1127): theirs alone, kept in this browser tab, never sent. An action from
// the ability book or a token's hover card fires at it; the token menu sets it ("Target"). A target that leaves the
// board, or this person's sight, simply stops being one where it is read.
import { useEffect, useState } from 'react';

let target: string | null = null;
const listeners = new Set<(id: string | null) => void>();

export const aim = {
  get: (): string | null => target,
  set(id: string | null): void {
    if (id === target) return;
    target = id;
    for (const l of listeners) l(id);
  },
  subscribe(l: (id: string | null) => void): () => void {
    listeners.add(l);
    return () => { listeners.delete(l); };
  },
};

export function useTarget(): string | null {
  const [id, setId] = useState(aim.get());
  useEffect(() => aim.subscribe(setId), []);
  return id;
}
